import { Injectable } from "@angular/core";
import { APP_SETTINGS } from "../../shared/models/backofficeConfiguration";
import { ExecuteService } from "../../shared/services/executeService.service";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { Observable } from "rxjs/Observable";
import { map, catchError } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { Filter } from "../model/Filter";
import { ValueItem } from "../model/ValueItem";
import { ApplicationItem } from "../model/ApplicationItem";
import { ApplicationRequest } from '../model/ApplicationRequest';

@Injectable()
export class ConfigurationService {
  private configurationApiUrl = APP_SETTINGS.ConfigurationApiUrl;

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) { }

  public GetValues(filter: Filter): Observable<ValueItem[]> {
    const url = `${this.configurationApiUrl}/configurationManager/GetByFilter`;
    let params = new HttpParams();
    if (filter.key) {
      params = params.set('key', filter.key);
    }
    if (filter.applicationId) {
      params = params.set('applicationId', filter.applicationId);
    }
    if (filter.value) {
      params = params.set('value', filter.value);
    }

    return this.executeService.ExecuteWithToken('get', url, params)
      .pipe(
        map(response => this.mapValueResponses(response)),
        catchError(this.errorHandler.handleError<object[]>('ConfigurationService_GetValues', [], true))
      );
  };

  public GetApplications(): Observable<ApplicationItem[]> {
    const url = `${this.configurationApiUrl}/configurationManager/GetApplications`;

    return this.executeService.ExecuteWithToken('get', url)
      .pipe(
        map(response => this.mapApplicationResponses(response)),
        catchError(this.errorHandler.handleError<object[]>('ConfigurationService_GetApplications', [], true))
      );
  };

  public CreateValue(value: ValueItem): Observable<object> {
    var url = `${this.configurationApiUrl}/configurationManager/Create`;
    var data = value;
    return this.executeService.ExecuteWithToken('post', url, null, data)
      .pipe(
        catchError(this.errorHandler.handleError<object>('ConfigurationService_CreateValue', null))
      );
  };

  public CreateApplication(app: ApplicationRequest): Observable<object> {
    var url = `${this.configurationApiUrl}/configurationManager/CreateApplication`;
    var data = app;
    return this.executeService.ExecuteWithToken('post', url, null, data)
      .pipe(
        catchError(this.errorHandler.handleError<object>('ConfigurationService_CreateApplication', null))
      );
  };

  public EditOrCreateValue(value: ValueItem): Observable<object> {
    var url = `${this.configurationApiUrl}configurationManager/EditOrCreate`;
    var data = {
      ApplicationId: value.Application.Id,
      Key: value.Key,
      Value: value.Value
    };
    return this.executeService.ExecuteWithToken('post', url, null, data)
      .pipe(
        catchError(this.errorHandler.handleError<object>('ConfigurationService_EditOrCreateValue', null))
      );
  };

  public DeleteValue(value: ValueItem): Observable<object> {
    var url = `${this.configurationApiUrl}/configurationManager/Delete`;
    let params = new HttpParams()
      .set('key', value.Key)
      .set('applicationId', value.Application.Id);

    return this.executeService.ExecuteWithToken('delete', url, params)
      .pipe(
        catchError(this.errorHandler.handleError<object>('ConfigurationService_DeleteValue', null))
      );
  };

  private mapValueResponses(values: any[]): any {
    let response: ValueItem[] = [];
    if (values != null) {
      response = values.map(b => ({
        Key: b.Key,
        Value: b.Value,
        Application: {
          Id: b.ApplicationSettingId,
          Name: b.ApplicationName
        } as ApplicationItem
      }));
    }
    return response;
  };

  private mapApplicationResponses(applications: any[]): any {
    let response: ApplicationItem[] = [];
    if (applications != null) {
      response = applications.map(b => ({
        Id: b.Id,
        Name: b.Name
      }));
    }
    return response;
  };
}



// WEBPACK FOOTER //
// ./src/app/configuration/services/configuration.service.ts